import React from 'react';
import { View, Text, StyleSheet, Pressable, useColorScheme } from 'react-native';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { useTranslation } from 'react-i18next';
import CustomLabel from '../CustomLabel/CustomLabel';
import { useTheme, useNavigation } from '@react-navigation/native';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'gr', label: 'Ελληνικά' }
];

const Selector = () => {
  const { colors } = useTheme()
  const navigation = useNavigation(); 
  const styles = makeStyles(colors)
  const { t, i18n } = useTranslation();
  const selectedLanguageCode = i18n.language;

  const setLanguage = code => {
     i18n.changeLanguage(code);
     navigation.goBack();
  };

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <CustomLabel
          type='MAJORSETTINGS'
          value={t('common:languageSelector')}
        />
        <Ionicons color={colors.text_primary} size={28} name='language-outline' />
      </View>
      {LANGUAGES.map(language => {
        const selectedLanguage = language.code === selectedLanguageCode;

        return (

          <Pressable
            key={language.code}
            style={styles.buttonContainer}
            disabled={selectedLanguage}
            onPress={() => setLanguage(language.code)}
          >
            <Text
              style={[selectedLanguage ? styles.selectedText : styles.text]}
            >
              {language.label}
            </Text>
            <View style={styles.line} />

          </Pressable>
        );
      })}
    </View>
  );
};

const makeStyles = (colors) => StyleSheet.create({
  container: {
    marginEnd: 30,
    paddingTop: 20,
    paddingHorizontal: 16,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom:'10%',
    justifyContent: 'space-between'
  },
  line: {
    borderBottomColor: colors.buttons_primary,
    borderBottomWidth: StyleSheet.hairlineWidth,
    marginTop: "5%",
    marginBottom: "3%",
  },
  title: {
    color: colors.text_primary,
    fontSize: 28,
    fontWeight: '600'
  },
  buttonContainer: {
    marginTop: '0%'
  },
  text: {
    fontSize: 14,
    margin: 5,
    color: colors.text_primary,
  },
  selectedText: {
    fontSize: 20,
    fontWeight: '600',
    color: colors.language_selector,
  }
});

export default Selector;